import React from 'react'
import styled from 'styled-components'
import { lightThemeColors } from '../../assets/style/colors'

const BenefitCard = ({ title, value, valueType, cardColor }) => {

    let cardBg = "rgba(21, 49, 91, 1)";
    let valueTypeBg = "rgba(74, 100, 149, 1)";

    switch (cardColor) {
        case "blue":
            cardBg = "rgba(21, 49, 91, 1)";
            valueTypeBg = "rgba(74, 100, 149, 1)";
            break;

        case "orange":
            cardBg = "rgba(198, 88, 54, 1)";
            valueTypeBg = "rgba(146, 47, 16, 1)";
            break;

        case "yellow":
            cardBg = "rgba(225, 190, 68, 1)";
            valueTypeBg = "rgba(129, 85, 0, 1)";
            break;

        default:
            break;
    }


    return (
        <Container cardBg={cardBg}>
            <TitleWrapper valueTypeBg={valueTypeBg}>
                <Title>{title}</Title>
            </TitleWrapper>
            <ValueWrapper>
                <Value>{value}</Value>
                <ValueType>{valueType}</ValueType>
            </ValueWrapper>
        </Container>
    )
}

export default BenefitCard

const Container = styled.div`
display:flex;
flex-direction:column;
gap:20px;
padding:30px;
border-radius:20px;
align-items:center;
min-height:240px;
background:${props => props.cardBg ? props.cardBg : lightThemeColors.darkColor};
overflow:hidden;
`
const TitleWrapper = styled.div`
display:flex;
align-items:center;
justify-content:center;
padding:10px 20px;
border-radius:8px;
background:${props => props.valueTypeBg ? props.valueTypeBg : lightThemeColors.darkColor};
`
const Title = styled.h3`
color:${lightThemeColors.lightColor};
font-weight: 500;
font-size: 17px;
line-height: 20px;
text-align:center;
`
const ValueWrapper = styled.div`
display:flex;
align-items:end;
gap:10px;

`
const Value = styled.p`
color:${lightThemeColors.lightColor};
font-weight: 500;
font-size: 80px;
line-height: 90px;

`
const ValueType = styled.p`
color:${lightThemeColors.lightColor};
font-family: Lato;
font-weight: 500;
font-size: 50px;
line-height: 50px;

`